import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Loader from "../../../core/common/loader";
import CommonSelect from "../../../core/common/commonSelect";
import api from "../../../services/api";
import Table from "../../../core/common/dataTable/index";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import PredefinedDateRanges from "../../../core/common/datePickerWithoutYear";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import { all_routes } from "../../router/all_routes";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import "./CallLog.module.css";
import StickyCallNote from "./stickyNote";
import { Button } from "react-bootstrap";
import { Modal, DatePicker, Button as ButtonAntd } from "antd";
import { Modal as ModalReact } from "react-bootstrap";
import type { Dayjs } from "dayjs";
import { useSelector } from "react-redux";
import { showBasicAlert } from "../../../core/common/useAlert";

const { RangePicker } = DatePicker;
const CallLogs = () => {
  const location = useLocation();
  const user = useSelector((state: any) => {
    return state.user.user;
  });

  const CALL_TYPES = {
    1: "INCOMING",
    2: "OUTGOING",
    3: "MISSED",
    4: "VOICEMAIL",
    5: "REJECTED",
    6: "BLOCKED",
    7: "ANSWERED EXTERNALLY",
    8: "CONNECTED",
    9: "NOT CONNECTED",
    10: "ALL",
    11: "CONNECTED MISSED",
  };
  const signature = localStorage.getItem("signature");
  const [isLoading, setIsLoading] = useState(false);
  const [companyList, setCompanyList] = useState<any[]>([]);
  const [data, setData] = useState<any>({});
  const [filteredData, setFilteredData] = useState<any>({ data });
  const [detailCallLogsType, setdetailCallLogsType] = useState<any[]>([]);
  const [isFilterActive, setIsFilterActive] = useState(false);
  const [isExporting, setIsExporting] = useState(false);
  const [isExportModalOpen, setIsExportModalOpen] = useState(false);
  const [isExportSummaryModalOpen, setIsExportSummaryModalOpen] =
    useState(false);
  const [exportRange, setExportRange] = useState<[Dayjs, Dayjs] | null>(null);

  const [showJourneyModal, setShowJourneyModal] = useState(false);
  const [selectedJourneyNumber, setSelectedJourneyNumber] = useState<
    string | null
  >(null);
  const [journeyData, setJourneyData] = useState<any[]>([]);

  const [selectedCompany, setSelectedCompany] = useState({
    companyId: "",
    companyName: "Select Company",
    companyType: "",
  });

  const [selectedTableType, setSelectedTableType] = useState("calls");
  const [selectedStartDate, setSelectedStartDate] =
    useState<moment.Moment | null>(moment());
  const [selectedEndDate, setSelectedEndDate] = useState<moment.Moment | null>(
    moment(),
  );
  const [formList, setFormList] = useState<any[]>([]);
  const [selectedForm, setSelectedForm] = useState({
    form_id: "",
    form_name: "Select Form",
    pipeline_id: "",
  });
  const [selectedExportUserIds, setSelectedExportUserIds] = useState<number[]>(
    [],
  );
  const [exportUserSelectAll, setExportUserSelectAll] = useState(true);
  const [selectedExportCallLogUserIds, setSelectedExportCallLogUserIds] =
    useState<number[]>([]);
  const [exportCallLogUserSelectAll, setExportCallLogUserSelectAll] =
    useState(true);

  const handleDateChange = (start: moment.Moment, end: moment.Moment) => {
    setSelectedStartDate(start);
    setSelectedEndDate(end);
    setIsFilterActive(true);
    setIsLoading(true);
    fetchCallLogs(selectedCompany, start, end);
  };

  const goLive = () => {
    setSelectedStartDate(moment());
    setSelectedEndDate(moment());
    setIsFilterActive(false);
    setIsLoading(true);
    fetchCallLogs(selectedCompany, moment(), moment());
  };
  const [inactiveEmployee, setinactiveEmployee] = useState<any[]>([]);

  useEffect(() => {
    fetchCompanyList();
  }, []);

  const fetchCompanyList = async () => {
    setIsLoading(true);
    try {
      const response = await api.post("userService/getAllCompanyList", {
        signature,
      });
      setCompanyList(response.data.data.data);

      const newCompany = {
        companyId: response.data.data.data[0].id,
        companyName: response.data.data.data[0].name,
        companyType: response.data.data.data[0].type,
      };

      setSelectedCompany(newCompany);
      fetchCallLogs(newCompany, selectedStartDate, selectedEndDate);
    } catch (error) {
      console.error("Error fetching companies:", error);
    }
  };

  const handleCompanyChange = async (selectedOption: any) => {
    if (!selectedOption) return;
    const [companyId, companyType] = selectedOption.value.split("-");
    setIsLoading(true);
    const newCompany = {
      companyId: companyId,
      companyName: selectedOption.label.split("-")[0].trim(),
      companyType: companyType,
    };

    setSelectedCompany(newCompany);
    setSelectedForm({
      form_id: "",
      form_name: "",
      pipeline_id: "",
    });
    fetchCallLogs(newCompany, selectedStartDate, selectedEndDate);
  };

  const fetchForms = async (company: any) => {
    try {
      const response = await api.post("leadService/getLeadFormsByCompany", {
        signature,
        company_id: company.companyId,
        company_type: company.companyType,
      });

      const forms = response.data.data.data || [];
      setFormList(forms);

      if (forms.length > 0) {
        const firstForm = forms[0];
        const newSelectedForm = {
          form_id: firstForm.key.toString(),
          form_name: firstForm.LeadFormName,
          pipeline_id: firstForm.pipeline_id.toString(),
        };

        setSelectedForm(newSelectedForm);

        if (firstForm.employees) {
          filterDataByFormEmployees(firstForm.employees);
        }
      } else {
        setSelectedForm({
          form_id: "",
          form_name: "No Forms Available",
          pipeline_id: "",
        });
      }
    } catch (error) {
      console.error("Error fetching forms:", error);
      setSelectedForm({
        form_id: "",
        form_name: "Error Loading Forms",
        pipeline_id: "",
      });
    }
  };

  const handleFormChange = (selectedOption: any) => {
    if (!selectedOption) return;

    if (selectedOption.value === "") {
      setSelectedForm({ form_id: "", form_name: "", pipeline_id: "" });
      setFilteredData(data);
    } else {
      const [pipeline_id, form_id] = selectedOption.value.split("-");
      const form = formList.find((f) => f.key === parseInt(form_id));

      setSelectedForm({
        form_id,
        form_name: selectedOption.label,
        pipeline_id,
      });

      if (form && form.employees) {
        filterDataByFormEmployees(form.employees);
      }
    }
  };
  const filterDataByFormEmployees = (employeeIds: number[]) => {
    if (!data.userDetailData) return;

    const filtered = {
      ...data,
      userDetailData: data.userDetailData.filter((user: any) =>
        employeeIds.includes(parseInt(user.user_id)),
      ),
    };

    setFilteredData(filtered);
  };
  const fetchCallLogs = async (
    company: any,
    start: any,
    end: any,
    formId = null,
  ) => {
    if (!company?.companyId) {
      return;
    }
    if (isExporting) {
      return;
    }

    try {
      const response = await api.post("callLogsService/getDashboardDetails", {
        signature,
        company_id: Number(company.companyId),
        company_type: company.companyType,
        start_date: moment(start).format("YYYY-MM-DD"),
        end_date: moment(end).format("YYYY-MM-DD"),
      });

      // 🛑 HARD GUARD
      if (!response || !response.data || !response.data.data) {
        console.warn("Invalid dashboard response", response);
        setData([]);
        setFilteredData([]);
        setinactiveEmployee([]);
        return;
      }

      const dashboardData = response.data.data;

      setData(dashboardData);

      if (selectedForm.form_id && selectedForm.form_id !== "") {
        const form = formList.find(
          (f) => f.key === parseInt(selectedForm.form_id),
        );
        if (form && form.employees) {
          const filtered = {
            ...dashboardData,
            userDetailData: dashboardData.userDetailData.filter((user: any) =>
              form.employees.includes(parseInt(user.user_id)),
            ),
          };
          setFilteredData(filtered);
        } else {
          setFilteredData(dashboardData);
        }
      } else {
        setFilteredData(dashboardData);
      }

      const inactiveEmployees =
        dashboardData.userDetailData?.filter((item: any) => {
          return (
            item.last_call_time &&
            moment.utc().diff(moment.utc(item.last_call_time), "minutes") > 10
          );
        }) || [];

      setinactiveEmployee(inactiveEmployees);
    } catch (error) {
      console.error("Error fetching call logs:", error);
      setData([]);
      setFilteredData([]);
      setinactiveEmployee([]);
    } finally {
      setIsLoading(false); // ✅ finally me hi hona chahiye
    }
  };

  useEffect(() => {
    if (selectedCompany && selectedCompany.companyId) {
      fetchForms(selectedCompany);
    }
  }, [selectedCompany]);

  useEffect(() => {
    if (
      selectedForm.form_id &&
      selectedForm.form_id !== "" &&
      data.userDetailData
    ) {
      const form = formList.find(
        (f) => f.key === parseInt(selectedForm.form_id),
      );
      if (form && form.employees) {
        const filtered = {
          ...data,
          userDetailData: data.userDetailData.filter((user: any) =>
            form.employees.includes(parseInt(user.user_id)),
          ),
        };
        setFilteredData(filtered);
      }
    }
  }, [selectedForm, data, formList]);

  useEffect(() => {
    if (!isFilterActive) {
      const interval = setInterval(() => {
        fetchCallLogs(selectedCompany, selectedStartDate, selectedEndDate);
      }, 60000);

      return () => clearInterval(interval); // Clean up interval
    }
  }, [selectedCompany, isFilterActive, selectedStartDate, selectedEndDate]);

  const formatDuration = (seconds: number) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = Math.round(seconds % 60); // Use Math.round() to avoid decimals
    return `${hours}h ${minutes}m ${secs}s`;
  };

  const openCallJourney = (record: any) => {
    fetchCallJourney(record);
    setShowJourneyModal(true);
  };

  const fetchCallJourney = async (data: any) => {
    setSelectedJourneyNumber(data.customer_mobile);
    const res = await api.post("callLogsService/getCallJourney", {
      user_id: data.user_id,
      customer_mobile: data.customer_mobile,
      start_date: selectedStartDate,
      end_date: selectedEndDate,
      company_id: selectedCompany.companyId,
      company_type: selectedCompany.companyType,
    });

    setJourneyData(res.data.data || []);
  };

  const columnsCalls = [
    {
      title: "Name",
      dataIndex: "name",
      render: (text: string, record: any) => (
        <div className="d-flex align-items-center file-name-icon">
          <Link
            to="#"
            onClick={(e: any) => e.preventDefault()}
            className="avatar avatar-rounded bg-success text-white d-inline-flex align-items-center justify-content-center border border-white"
            style={{
              width: "40px",
              height: "40px",
              fontSize: "14px",
              overflow: "hidden",
            }}
          >
            {record.Image &&
            record.Image.trim() !== "" &&
            record.Image.trim() !== "null" &&
            record.Image.trim() !== null ? (
              <ImageWithBasePath
                src={record.Image}
                className="img-fluid"
                alt="img"
              />
            ) : (
              <span>{record.name?.charAt(0).toUpperCase() || "U"}</span>
            )}
          </Link>

          <div className="ms-2">
            <h6 className="fw-medium">
              <Link to="#" onClick={(e: any) => e.preventDefault()}>
                {text}
              </Link>
            </h6>
          </div>
        </div>
      ),
      sorter: (a: any, b: any) => a.name.length - b.name.length,
    },
    ...(!isFilterActive
      ? [
          {
            title: "Last Call Time",
            dataIndex: "last_call_time",
            render: (value: string) => {
              if (!value) return "N/A";

              // Convert UTC value to IST (+5.5 hours)
              const time = moment(value);
              const now = moment(); // Current time in IST

              const diffInMinutes = now.diff(time, "minutes");
              const hours = Math.floor(diffInMinutes / 60);
              const minutes = diffInMinutes % 60;

              let color = "";
              if (diffInMinutes > 10) {
                color = "red";
              } else if (diffInMinutes >= 5) {
                color = "orange";
              }

              return (
                <div style={{ color }}>
                  {/* Show IST time in AM/PM */}
                  <div>{time.format("DD-MM-YYYY hh:mm:ss A")}</div>
                  <small>
                    ({hours}h {minutes}m ago)
                  </small>
                </div>
              );
            },
            sorter: (a: any, b: any) =>
              moment(a.last_call_time).unix() - moment(b.last_call_time).unix(),
          },
        ]
      : []),
    {
      title: "Total Calls",
      dataIndex: "total_calls",
      render: (text: string, record: any) => (
        <div
          className="d-flex align-items-center file-name-icon"
          onClick={() => fetchCallLogsDetails("ALL", record.user_id)}
          style={{ cursor: "pointer" }}
        >
          <div className="ms-2">
            <h6 className="fw-medium">
              <Link
                onClick={(e: any) => e.preventDefault()}
                to="#"
                data-bs-toggle="modal"
                data-bs-target="#show_detail_call_logs"
              >
                {text}
              </Link>
            </h6>
          </div>
        </div>
      ),
      sorter: (a: any, b: any) => a.total_calls - b.total_calls,
    },
    {
      title: "Outgoing",
      dataIndex: "outgoing_calls",
      render: (text: string, record: any) => (
        <div
          className="d-flex align-items-center file-name-icon"
          onClick={() => fetchCallLogsDetails("OUTGOING", record.user_id)}
          style={{ cursor: "pointer" }}
        >
          <div className="ms-2">
            <h6 className="fw-medium">
              <Link
                to="#"
                onClick={(e: any) => e.preventDefault()}
                data-bs-toggle="modal"
                data-bs-target="#show_detail_call_logs"
              >
                {text}
              </Link>
            </h6>
          </div>
        </div>
      ),
      sorter: (a: any, b: any) => a.outgoing_calls - b.outgoing_calls,
    },
    {
      title: "Incoming",
      dataIndex: "incoming_calls",
      render: (text: string, record: any) => (
        <div
          className="d-flex align-items-center file-name-icon"
          onClick={() => fetchCallLogsDetails("INCOMING", record.user_id)}
          style={{ cursor: "pointer" }}
        >
          <div className="ms-2">
            <h6 className="fw-medium">
              <Link
                to="#"
                onClick={(e: any) => e.preventDefault()}
                data-bs-toggle="modal"
                data-bs-target="#show_detail_call_logs"
              >
                {text}
              </Link>
            </h6>
          </div>
        </div>
      ),
      sorter: (a: any, b: any) => a.incoming_calls - b.incoming_calls,
    },
    {
      title: "Connected",
      dataIndex: "connected_calls",
      render: (text: string, record: any) => (
        <div
          className="d-flex align-items-center file-name-icon"
          onClick={() => fetchCallLogsDetails("CONNECTED", record.user_id)}
          style={{ cursor: "pointer" }}
        >
          <div className="ms-2">
            <h6 className="fw-medium">
              <Link
                to="#"
                onClick={(e: any) => e.preventDefault()}
                data-bs-toggle="modal"
                data-bs-target="#show_detail_call_logs"
              >
                {text}
              </Link>
            </h6>
          </div>
        </div>
      ),
      sorter: (a: any, b: any) => a.connected_calls - b.connected_calls,
    },
    {
      title: "Missed",
      dataIndex: "missed_calls",
      render: (text: string, record: any) => (
        <div
          className="d-flex align-items-center file-name-icon"
          onClick={() => fetchCallLogsDetails("MISSED", record.user_id)}
          style={{ cursor: "pointer" }}
        >
          <div className="ms-2">
            <h6 className="fw-medium">
              <Link
                to="#"
                onClick={(e: any) => e.preventDefault()}
                data-bs-toggle="modal"
                data-bs-target="#show_detail_call_logs"
              >
                {text}
              </Link>
            </h6>
          </div>
        </div>
      ),
      sorter: (a: any, b: any) => a.missed_calls - b.missed_calls,
    },
    {
      title: "Connected Missed Calls",
      dataIndex: "connected_missed_calls",
      render: (text: string, record: any) => (
        <div
          className="d-flex align-items-center file-name-icon"
          onClick={() =>
            fetchCallLogsDetails("CONNECTED_MISSED", record.user_id)
          }
          style={{ cursor: "pointer" }}
        >
          <div className="ms-2">
            <h6 className="fw-medium">
              <Link
                to="#"
                onClick={(e: any) => e.preventDefault()}
                data-bs-toggle="modal"
                data-bs-target="#show_detail_call_logs"
              >
                {text}
              </Link>
            </h6>
          </div>
        </div>
      ),
      sorter: (a: any, b: any) => a.missed_calls - b.missed_calls,
    },
    {
      title: "Not Connected",
      dataIndex: "not_connected_calls",
      render: (text: string, record: any) => (
        <div
          className="d-flex align-items-center file-name-icon"
          onClick={() => fetchCallLogsDetails("NOTCONNECTED", record.user_id)}
          style={{ cursor: "pointer" }}
        >
          <div className="ms-2">
            <h6 className="fw-medium">
              <Link
                to="#"
                onClick={(e: any) => e.preventDefault()}
                data-bs-toggle="modal"
                data-bs-target="#show_detail_call_logs"
              >
                {text}
              </Link>
            </h6>
          </div>
        </div>
      ),
      sorter: (a: any, b: any) => a.not_connected_calls - b.not_connected_calls,
    },
  ];
  const columnsDuration = [
    {
      title: "Name",
      dataIndex: "name",
      render: (text: string, record: any) => (
        <div className="d-flex align-items-center file-name-icon">
          <Link
            to="#"
            onClick={(e: any) => e.preventDefault()}
            className="avatar avatar-rounded bg-success text-white d-inline-flex align-items-center justify-content-center border border-white"
            style={{
              width: "40px",
              height: "40px",
              fontSize: "14px",
              overflow: "hidden",
            }}
          >
            {record.Image &&
            record.Image.trim() !== "" &&
            record.Image.trim() !== "null" &&
            record.Image.trim() !== null ? (
              <ImageWithBasePath
                src={record.Image}
                className="img-fluid"
                alt="img"
              />
            ) : (
              <span>{record.name?.charAt(0).toUpperCase() || "U"}</span>
            )}
          </Link>

          <div className="ms-2">
            <h6 className="fw-medium">
              <Link to="#" onClick={(e: any) => e.preventDefault()}>
                {text}
              </Link>
            </h6>
          </div>
        </div>
      ),
      sorter: (a: any, b: any) => a.name.length - b.name.length,
    },
    {
      title: "Outgoing",
      dataIndex: "outgoing_call_duration",
      sorter: (a: any, b: any) =>
        a.outgoing_call_duration - b.outgoing_call_duration,
      render: (value: number) => formatDuration(value), // Format duration
    },
    {
      title: "Incoming",
      dataIndex: "incoming_call_duration",
      sorter: (a: any, b: any) =>
        a.incoming_call_duration - b.incoming_call_duration,
      render: (value: number) => formatDuration(value), // Format duration
    },
    {
      title: "Total Duration",
      dataIndex: "total_call_duration",
      sorter: (a: any, b: any) => a.total_call_duration - b.total_call_duration,
      render: (value: number) => formatDuration(value), // Format duration
    },
    {
      title: "Avg Incoming",
      dataIndex: "avg_incoming_call_duration",
      sorter: (a: any, b: any) =>
        a.avg_incoming_call_duration - b.avg_incoming_call_duration,
      render: (value: number) => formatDuration(value), // Format duration
    },
    {
      title: "Avg Outgoing",
      dataIndex: "avg_outgoing_call_duration",
      sorter: (a: any, b: any) =>
        a.avg_outgoing_call_duration - b.avg_outgoing_call_duration,
      render: (value: number) => formatDuration(value), // Format duration
    },
  ];
  const columnDetails = [
    {
      title: "Duration",
      dataIndex: "call_duration",
      sorter: (a: any, b: any) => a.call_duration - b.call_duration,
      render: (value: number) => formatDuration(value || 0), // Format duration
    },
    {
      title: "Customer Mobile",
      dataIndex: "customer_mobile",
    },
    {
      title: "Date",
      dataIndex: "call_date",
      render: (value: any) => moment(value).format("DD-MM-YYYY"), // Format duration
    },
    {
      title: "Start Time",
      dataIndex: "start_time",
      render: (value: any) => moment(value).format("hh:mm:ss A"), // Format as time only
    },
    {
      title: "End Time",
      dataIndex: "end_time",
      render: (value: any) => moment(value).format("hh:mm:ss A"), // Format as time only
    },
    {
      title: "Call Type",
      dataIndex: "call_type",
      render: (value: keyof typeof CALL_TYPES) => CALL_TYPES[value],
    },
    {
      title: "Recording",
      dataIndex: "url",
      render: (text: string, record: any) => (
        <div className="d-flex align-items-center file-name-icon">
          <div className="ms-2">
            <h6 className="fw-medium">
              <Link to={`${text}${location?.search}`}>Download</Link>
            </h6>
          </div>
        </div>
      ),
    },
    {
      title: "View Journey",
      dataIndex: "view_journey",
      render: (_: any, record: any) => (
        <button
          className="btn btn-sm btn-outline-primary"
          onClick={() => openCallJourney(record)}
        >
          View Journey
        </button>
      ),
    },
  ];

  const handleExportExcel = () => {
    setIsExportSummaryModalOpen(true);
  };

  const secondsToHHMMSS = (seconds: number = 0) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);

    return [
      hrs.toString().padStart(2, "0"),
      mins.toString().padStart(2, "0"),
      secs.toString().padStart(2, "0"),
    ].join(":");
  };

  const handleExportExcelWithDateRange = async (
    startDate: Dayjs,
    endDate: Dayjs,
  ) => {
    setIsLoading(true);
    try {
      // Use selected users OR all users if "All" is checked
      const userIds = exportUserSelectAll
        ? filteredData.userDetailData?.map((user: any) => user.user_id) || []
        : selectedExportUserIds;

      if (userIds.length === 0) {
        console.error("No users found");
        setIsLoading(false);
        return;
      }

      const response = await api.post(
        "callLogsService/getDailyCallStatistics",
        {
          signature,
          start_date: startDate.format("YYYY-MM-DD"),
          end_date: endDate.format("YYYY-MM-DD"),
          company_id: selectedCompany.companyId,
          company_type: selectedCompany.companyType,
          user_ids: userIds,
        },
      );

      const dailyStats = response.data.data || [];

      let filteredStats = dailyStats;
      if (userIds.length > 0) {
        filteredStats = dailyStats.filter((stat: any) =>
          userIds.includes(stat.user_id),
        );
      }

      const formattedData = filteredStats.map((stat: any) => ({
        Date: moment(stat.date).format("DD-MM-YYYY"),
        Emp_id: stat.emp_id,
        Name: stat.user_name,
        "Total Calls": stat.total_calls,
        "Incoming Calls": stat.incoming_calls,
        "Outgoing Calls": stat.outgoing_calls,
        "Connected Calls": stat.connected_calls,
        "Not Connected Calls": stat.not_connected_calls,
        "Missed Calls": stat.missed_calls,
        "Voicemail Calls": stat.voicemail_calls,
        "Rejected Calls": stat.rejected_calls,
        "Blocked Calls": stat.blocked_calls,
        "Answered Externally": stat.answered_externally_calls,
        "Connected Missed Calls": stat.connected_missed_calls,
        "Total Duration (HH:mm:ss)": secondsToHHMMSS(stat.total_duration),
        "Incoming Duration (HH:mm:ss)": secondsToHHMMSS(stat.incoming_duration),
        "Outgoing Duration (HH:mm:ss)": secondsToHHMMSS(stat.outgoing_duration),
        "Avg Incoming Duration (HH:mm:ss)": secondsToHHMMSS(
          stat.avg_incoming_duration,
        ),
        "Avg Outgoing Duration (HH:mm:ss)": secondsToHHMMSS(
          stat.avg_outgoing_duration,
        ),
        "Last Call Time": stat.last_call_time
          ? moment(stat.last_call_time).format("DD-MM-YYYY HH:mm:ss")
          : "N/A",
        "Last Connected Call Time": stat.last_connected_call_time
          ? moment(stat.last_connected_call_time).format("DD-MM-YYYY HH:mm:ss")
          : "N/A",
      }));

      const ws = XLSX.utils.json_to_sheet(formattedData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Daily Call Summary");

      const filename = `daily-call-summary-${startDate.format("DD-MM-YYYY")}-to-${endDate.format("DD-MM-YYYY")}.xlsx`;
      XLSX.writeFile(wb, filename);
    } catch (error: any) {
      const errorMsg = error?.data?.message?.[0]?.msg || "Something went wrong";
      showBasicAlert(errorMsg);
    } finally {
      setIsLoading(false);
    }
  };

  const handleExportCallLogsExcel = async () => {
    if (!exportRange) return;

    setIsExporting(true);
    setIsLoading(true);

    try {
      const userIds = exportCallLogUserSelectAll
        ? filteredData.userDetailData?.map((user: any) => user.user_id) || []
        : selectedExportCallLogUserIds;

      if (userIds.length === 0) {
        console.error("No users found");
        setIsLoading(false);
        setIsExporting(false);
        return;
      }

      const res = await api.post(
        "callLogsService/download_call_logs",
        {
          signature,
          start_date: exportRange[0].format("YYYY-MM-DD"),
          end_date: exportRange[1].format("YYYY-MM-DD"),
          companyId: selectedCompany.companyId,
          companyType: selectedCompany.companyType,
          user_ids: userIds,
        },
        { responseType: "blob" },
      );

      const arrayBuffer = await res.data.arrayBuffer();
      const workbook = XLSX.read(arrayBuffer, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      worksheet["E1"].v = "Duration";
      worksheet["E1"].t = "s";

      if (!worksheet["!ref"]) {
        throw new Error("Worksheet range not found");
      }

      const range = XLSX.utils.decode_range(worksheet["!ref"]);

      for (let r = 1; r <= range.e.r; r++) {
        const cellAddress = XLSX.utils.encode_cell({ r, c: 4 });
        const cell = worksheet[cellAddress];
        if (!cell || !cell.v) continue;

        const seconds = Number(cell.v);
        const excelTime = seconds / 86400;

        worksheet[cellAddress] = {
          v: excelTime,
          t: "n",
          z: "[hh]:mm:ss",
        };
      }

      worksheet["!cols"] = [
        { wch: 20 },
        { wch: 15 },
        { wch: 12 },
        { wch: 14 },
        { wch: 12 },
        { wch: 12 },
        { wch: 12 },
        { wch: 22 },
      ];

      Object.keys(worksheet).forEach((cell) => {
        if (!/^[A-Z]+[0-9]+$/.test(cell)) return;
        const col = cell.replace(/[0-9]/g, "");

        if (col === "F" || col === "G") {
          worksheet[cell].z = "hh:mm:ss AM/PM";
        }

        if (col === "H") {
          worksheet[cell].z = "dd-mm-yyyy";
        }
      });

      const fixedWorkbook = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      const blob = new Blob([fixedWorkbook], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `call-logs-${Date.now()}.xlsx`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
      setIsExporting(false);
    }
  };

  const fetchCallLogsDetails = async (
    type: string,
    userId: string,
    date?: string,
  ) => {
    try {
      setIsExporting(true);
      setIsLoading(true);

      const isDateWise = !!date; // true when called from date-wise table
      const endpoint = isDateWise
        ? "callLogsService/getUserCallLogsByTypeAndDate"
        : "callLogsService/getUserCallLogsByType";

      const params = {
        signature,
        type,
        start_date: date ?? moment(selectedStartDate).format("YYYY-MM-DD"),
        end_date: date ?? moment(selectedEndDate).format("YYYY-MM-DD"),
        user_id: parseInt(userId),
        company_id: selectedCompany.companyId,
        company_type: selectedCompany.companyType,
      };

      const response = await api.post(endpoint, params);
      setdetailCallLogsType(response.data.data);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching call logs:", error);
      setIsLoading(false);
    }
  };

  return (
    <>
      {isLoading && <Loader />}

      <StickyCallNote callData={inactiveEmployee} />
      <div className="page-wrapper">
        <div className="content">
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Call Logs</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.superAdminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Application</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Call Logs
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="me-3 mb-2">
                <CommonSelect
                  options={companyList.map((company) => ({
                    value: `${company.id}-${company.type}`,
                    label: `${company.name} - ${company.type}`,
                  }))}
                  defaultValue={{
                    value: `${selectedCompany.companyId}-${selectedCompany.companyType}`,
                    label: `${selectedCompany.companyName} - ${selectedCompany.companyType}`,
                  }}
                  onChange={handleCompanyChange}
                />
              </div>
              <div className="me-3 mb-2">
                <CommonSelect
                  options={formList.map((form: any) => ({
                    value: `${form.pipeline_id}-${form.key}`,
                    label: form.LeadFormName,
                  }))}
                  defaultValue={{
                    value: selectedForm.pipeline_id
                      ? `${selectedForm.pipeline_id}-${selectedForm.form_id}`
                      : "",
                    label: selectedForm.form_name,
                  }}
                  onChange={handleFormChange}
                />
              </div>

              <div className="me-2 mb-2">
                <div className="dropdown">
                  <Link
                    to="#"
                    onClick={(e: any) => e.preventDefault()}
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    <i className="ti ti-file-export me-1" />
                    Export Call Logs
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                        onClick={(e) => {
                          e.preventDefault();
                          setIsExportModalOpen(true);
                        }}
                      >
                        <i className="ti ti-file-type-xls me-1" />
                        Export as Excel
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              {user?.userDetails?.role_char?.toLowerCase() !== "employee" && (
                <div className="me-2 mb-2">
                  <div className="dropdown">
                    <Link
                      to="#"
                      onClick={(e: any) => e.preventDefault()}
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      <i className="ti ti-file-export me-1" />
                      Export Overview
                    </Link>
                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                          onClick={(e: any) => {
                            e.preventDefault();
                            handleExportExcel();
                          }}
                        >
                          <i className="ti ti-file-type-xls me-1" />
                          Export as Excel{" "}
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              )}

              {user?.userDetails?.role_char?.toLowerCase() === "employee" && (
                <div className="me-2 mb-2">
                  <div className="dropdown">
                    <Link
                      to="#"
                      onClick={(e: any) => e.preventDefault()}
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      <i className="ti ti-file-export me-1" />
                      Export My Report
                    </Link>
                    <ul className="dropdown-menu dropdown-menu-end p-3">
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                          onClick={(e: any) => {
                            e.preventDefault();
                            setIsExportSummaryModalOpen(true);
                          }}
                        >
                          <i className="ti ti-file-type-xls me-1" />
                          Export as Excel
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              )}
              <div className="ms-2 head-icons">
                <CollapseHeader />
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-body">
              <div className="row">
                {(selectedTableType === "calls" ||
                  selectedTableType.toLowerCase() === "durations") && (
                  <div className="row g-3">
                    {[
                      {
                        label:
                          selectedTableType === "calls"
                            ? "Today Connected Calls"
                            : "Today Calls Duration",
                        icon: "ti-phone",
                        value:
                          selectedTableType === "calls"
                            ? filteredData?.today_call || 0
                            : formatDuration(
                                filteredData?.total_call_duration_today || 0,
                              ),
                      },
                      {
                        label:
                          selectedTableType === "calls"
                            ? "Weekly Connected Calls"
                            : "Weekly Calls Duration",
                        icon: "ti-calendar-week",
                        value:
                          selectedTableType === "calls"
                            ? filteredData?.weekly_call || 0
                            : formatDuration(
                                filteredData?.total_call_duration_weekly || 0,
                              ),
                      },
                      {
                        label:
                          selectedTableType === "calls"
                            ? "Monthly Connected Calls"
                            : "Monthly Calls Duration",
                        icon: "ti-calendar-month",
                        value:
                          selectedTableType === "calls"
                            ? filteredData?.monthly_call || 0
                            : formatDuration(
                                filteredData?.total_call_duration_monthly || 0,
                              ),
                      },
                      {
                        label: "Total Calls Duration",
                        icon: "ti-clock",
                        value: formatDuration(
                          filteredData?.total_call_duration || 0,
                        ),
                      },
                    ].map((item, index) => (
                      <div className="col-lg-3 col-md-6 d-flex" key={index}>
                        <div className="card call-metric-card flex-fill">
                          <div className="card-body d-flex align-items-center gap-3">
                            <span className="avatar avatar-lg bg-primary">
                              <i className={`ti ${item.icon}`} />
                            </span>
                            <div className="overflow-hidden">
                              <p className="metric-label text-muted mb-1 text-truncate">
                                {item.label}
                              </p>
                              <h4 className="metric-value mb-0">
                                {item.value}
                              </h4>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <div className="card">
                <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                  <h5>Call Logs List</h5>
                  <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                    {isFilterActive && (
                      <div className="me-3">
                        <Button onClick={goLive}>
                          <span style={{ color: "white" }}>Live Update</span>
                        </Button>
                      </div>
                    )}

                    <div className="me-3">
                      <div className="input-icon-end position-relative">
                        <PredefinedDateRanges onDateChange={handleDateChange} />
                        <span className="input-icon-addon">
                          <i className="ti ti-chevron-down" />
                        </span>
                      </div>
                    </div>
                    <div className="dropdown me-3">
                      <Link
                        to="#"
                        onClick={(e: any) => e.preventDefault()}
                        className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                        data-bs-toggle="dropdown"
                      >
                        TOTAL {selectedTableType.toUpperCase()}
                      </Link>
                      <ul className="dropdown-menu dropdown-menu-end p-3">
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item rounded-1"
                            onClick={(e: any) => {
                              e.preventDefault();
                              setSelectedTableType("calls");
                            }}
                          >
                            Calls
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item rounded-1"
                            onClick={(e: any) => {
                              e.preventDefault();
                              setSelectedTableType("durations");
                            }}
                          >
                            Durations
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                {selectedCompany.companyId && (
                  <div className="mt-4">
                    <div className="card-body p-0">
                      <Table
                        key={"id"}
                        columns={
                          selectedTableType === "calls"
                            ? columnsCalls
                            : columnsDuration
                        }
                        dataSource={filteredData.userDetailData}
                        Selection={false}
                        onFilterStatusChange={(status: any) =>
                          setIsFilterActive(status)
                        }
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="show_detail_call_logs"
          style={{ width: "100%" }}
        >
          <div className="modal-dialog modal-fullscreen">
            <div className="modal-content">
              {/* Header with close button */}
              <div className="modal-header">
                <h5 className="modal-title">Call Logs Details</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setIsExporting(false);
                  }}
                ></button>
              </div>

              {/* Body */}
              <div className="modal-body p-0">
                <Table
                  key={JSON.stringify(detailCallLogsType)}
                  dataSource={detailCallLogsType}
                  columns={columnDetails}
                  Selection={false}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        title="Export Call Logs"
        open={isExportModalOpen}
        onCancel={() => {
          setIsExportModalOpen(false);
          setSelectedExportCallLogUserIds([]);
          setExportCallLogUserSelectAll(true);
        }}
        footer={null}
      >
        <div className="mb-3">
          <label className="form-label">Select Date Range</label>
          <RangePicker
            style={{ width: "100%" }}
            value={exportRange}
            onChange={(dates) => setExportRange(dates as [Dayjs, Dayjs])}
            format="DD-MM-YYYY"
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Select Users</label>

          {user?.userDetails?.role_char?.toLowerCase() === "employee" ? (
            <div
              style={{
                border: "1px solid #d9d9d9",
                borderRadius: "6px",
                padding: "8px",
              }}
            >
              <div className="d-flex align-items-center gap-2">
                <div
                  className="avatar avatar-sm bg-success text-white d-inline-flex align-items-center justify-content-center"
                  style={{
                    width: "32px",
                    height: "32px",
                    borderRadius: "50%",
                    fontSize: "13px",
                    overflow: "hidden",
                    flexShrink: 0,
                  }}
                >
                  {user?.userDetails?.profile_pic &&
                  user.userDetails.profile_pic.trim() !== "" &&
                  user.userDetails.profile_pic !== "NULL" ? (
                    <img
                      src={user.userDetails.profile_pic}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                      alt="profile"
                    />
                  ) : (
                    <span>
                      {user?.userDetails?.fname?.charAt(0).toUpperCase() || "U"}
                    </span>
                  )}
                </div>
                <span className="fw-medium">
                  {user?.userDetails?.fname} {user?.userDetails?.lname}
                </span>
                <span className="badge bg-primary ms-auto">You</span>
              </div>
            </div>
          ) : (
            // Admin/Manager: show all users with checkboxes
            <>
              <div
                style={{
                  maxHeight: "250px",
                  overflowY: "auto",
                  border: "1px solid #d9d9d9",
                  borderRadius: "6px",
                  padding: "8px",
                }}
              >
                {/* All Users option */}
                <div
                  className="form-check mb-2 d-flex align-items-center"
                  style={{ cursor: "pointer" }}
                >
                  <input
                    className="form-check-input me-2"
                    type="checkbox"
                    id="export-call-log-user-all"
                    checked={exportCallLogUserSelectAll}
                    onChange={(e) => {
                      setExportCallLogUserSelectAll(e.target.checked);
                      if (e.target.checked) setSelectedExportCallLogUserIds([]);
                    }}
                  />
                  <span
                    className="avatar avatar-sm bg-primary text-white d-inline-flex align-items-center justify-content-center me-2"
                    style={{
                      width: "32px",
                      height: "32px",
                      borderRadius: "50%",
                      fontSize: "13px",
                    }}
                  >
                    <i className="ti ti-users" />
                  </span>
                  <label
                    className="form-check-label fw-bold mb-0"
                    htmlFor="export-call-log-user-all"
                  >
                    All Users
                  </label>
                </div>

                <hr className="my-1" />

                {/* Individual users */}
                {filteredData?.userDetailData?.map((u: any) => (
                  <div
                    key={u.user_id}
                    className="form-check mb-2 d-flex align-items-center"
                    style={{ cursor: "pointer" }}
                  >
                    <input
                      className="form-check-input me-2"
                      type="checkbox"
                      id={`export-call-log-user-${u.user_id}`}
                      checked={
                        !exportCallLogUserSelectAll &&
                        selectedExportCallLogUserIds.includes(u.user_id)
                      }
                      onChange={(e) => {
                        setExportCallLogUserSelectAll(false);
                        if (e.target.checked) {
                          setSelectedExportCallLogUserIds((prev) => [
                            ...prev,
                            u.user_id,
                          ]);
                        } else {
                          setSelectedExportCallLogUserIds((prev) =>
                            prev.filter((id) => id !== u.user_id),
                          );
                        }
                      }}
                    />
                    <div
                      className="avatar avatar-sm bg-success text-white d-inline-flex align-items-center justify-content-center me-2"
                      style={{
                        width: "32px",
                        height: "32px",
                        borderRadius: "50%",
                        fontSize: "13px",
                        overflow: "hidden",
                        flexShrink: 0,
                      }}
                    >
                      {u.Image &&
                      u.Image.trim() !== "" &&
                      u.Image.trim() !== "null" ? (
                        <ImageWithBasePath
                          src={u.Image}
                          className="img-fluid"
                          alt={u.name}
                        />
                      ) : (
                        <span>{u.name?.charAt(0).toUpperCase() || "U"}</span>
                      )}
                    </div>
                    <label
                      className="form-check-label mb-0"
                      htmlFor={`export-call-log-user-${u.user_id}`}
                      style={{ cursor: "pointer" }}
                    >
                      {u.name}
                    </label>
                  </div>
                ))}
              </div>

              {/* Show selected count if not all */}
              {!exportCallLogUserSelectAll && (
                <small className="text-muted mt-1 d-block">
                  {selectedExportCallLogUserIds.length} user(s) selected
                </small>
              )}
            </>
          )}
        </div>

        <div className="text-end">
          <Button onClick={() => setIsExportModalOpen(false)} className="me-2">
            Cancel
          </Button>

          <ButtonAntd
            type="primary"
            disabled={
              !exportRange ||
              (!exportCallLogUserSelectAll &&
                selectedExportCallLogUserIds.length === 0)
            }
            loading={isLoading}
            onClick={() => {
              if (!exportRange) return;
              setIsExportModalOpen(false);
              handleExportCallLogsExcel();
            }}
          >
            Download Excel
          </ButtonAntd>
        </div>
      </Modal>

      <Modal
        title="Export Call Overview"
        open={isExportSummaryModalOpen}
        onCancel={() => {
          setIsExportSummaryModalOpen(false);
          setSelectedExportUserIds([]);
          setExportUserSelectAll(true);
        }}
        footer={null}
      >
        <div className="mb-3">
          <label className="form-label">Select Date Range</label>
          <RangePicker
            style={{ width: "100%" }}
            value={exportRange}
            onChange={(dates) => setExportRange(dates as [Dayjs, Dayjs])}
            format="DD-MM-YYYY"
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Select Users</label>

          {user?.userDetails?.role_char?.toLowerCase() === "employee" ? (
            <div
              style={{
                border: "1px solid #d9d9d9",
                borderRadius: "6px",
                padding: "8px",
              }}
            >
              <div className="d-flex align-items-center gap-2">
                <div
                  className="avatar avatar-sm bg-success text-white d-inline-flex align-items-center justify-content-center"
                  style={{
                    width: "32px",
                    height: "32px",
                    borderRadius: "50%",
                    fontSize: "13px",
                    overflow: "hidden",
                    flexShrink: 0,
                  }}
                >
                  {user?.userDetails?.profile_pic &&
                  user.userDetails.profile_pic.trim() !== "" &&
                  user.userDetails.profile_pic !== "NULL" ? (
                    <img
                      src={user.userDetails.profile_pic}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                      alt="profile"
                    />
                  ) : (
                    <span>
                      {user?.userDetails?.fname?.charAt(0).toUpperCase() || "U"}
                    </span>
                  )}
                </div>
                <span className="fw-medium">
                  {user?.userDetails?.fname} {user?.userDetails?.lname}
                </span>
                <span className="badge bg-primary ms-auto">You</span>
              </div>
            </div>
          ) : (
            // Admin/Manager: show all users with checkboxes
            <>
              <div
                style={{
                  maxHeight: "250px",
                  overflowY: "auto",
                  border: "1px solid #d9d9d9",
                  borderRadius: "6px",
                  padding: "8px",
                }}
              >
                {/* All Users option */}
                <div
                  className="form-check mb-2 d-flex align-items-center"
                  style={{ cursor: "pointer" }}
                >
                  <input
                    className="form-check-input me-2"
                    type="checkbox"
                    id="export-user-all"
                    checked={exportUserSelectAll}
                    onChange={(e) => {
                      setExportUserSelectAll(e.target.checked);
                      if (e.target.checked) setSelectedExportUserIds([]);
                    }}
                  />
                  <span
                    className="avatar avatar-sm bg-primary text-white d-inline-flex align-items-center justify-content-center me-2"
                    style={{
                      width: "32px",
                      height: "32px",
                      borderRadius: "50%",
                      fontSize: "13px",
                    }}
                  >
                    <i className="ti ti-users" />
                  </span>
                  <label
                    className="form-check-label fw-bold mb-0"
                    htmlFor="export-user-all"
                  >
                    All Users
                  </label>
                </div>

                <hr className="my-1" />

                {/* Individual users */}
                {filteredData?.userDetailData?.map((u: any) => (
                  <div
                    key={u.user_id}
                    className="form-check mb-2 d-flex align-items-center"
                    style={{ cursor: "pointer" }}
                  >
                    <input
                      className="form-check-input me-2"
                      type="checkbox"
                      id={`export-user-${u.user_id}`}
                      checked={
                        !exportUserSelectAll &&
                        selectedExportUserIds.includes(u.user_id)
                      }
                      onChange={(e) => {
                        setExportUserSelectAll(false);
                        if (e.target.checked) {
                          setSelectedExportUserIds((prev) => [
                            ...prev,
                            u.user_id,
                          ]);
                        } else {
                          setSelectedExportUserIds((prev) =>
                            prev.filter((id) => id !== u.user_id),
                          );
                        }
                      }}
                    />
                    <div
                      className="avatar avatar-sm bg-success text-white d-inline-flex align-items-center justify-content-center me-2"
                      style={{
                        width: "32px",
                        height: "32px",
                        borderRadius: "50%",
                        fontSize: "13px",
                        overflow: "hidden",
                        flexShrink: 0,
                      }}
                    >
                      {u.Image &&
                      u.Image.trim() !== "" &&
                      u.Image.trim() !== "null" ? (
                        <ImageWithBasePath
                          src={u.Image}
                          className="img-fluid"
                          alt={u.name}
                        />
                      ) : (
                        <span>{u.name?.charAt(0).toUpperCase() || "U"}</span>
                      )}
                    </div>
                    <label
                      className="form-check-label mb-0"
                      htmlFor={`export-user-${u.user_id}`}
                      style={{ cursor: "pointer" }}
                    >
                      {u.name}
                    </label>
                  </div>
                ))}
              </div>

              {/* Show selected count if not all */}
              {!exportUserSelectAll && (
                <small className="text-muted mt-1 d-block">
                  {selectedExportUserIds.length} user(s) selected
                </small>
              )}
            </>
          )}
        </div>

        <div className="text-end">
          <Button
            onClick={() => setIsExportSummaryModalOpen(false)}
            className="me-2"
          >
            Cancel
          </Button>
          <ButtonAntd
            type="primary"
            disabled={
              !exportRange ||
              (!exportUserSelectAll && selectedExportUserIds.length === 0)
            }
            loading={isLoading}
            onClick={() => {
              if (!exportRange) return;
              setIsExportSummaryModalOpen(false);
              handleExportExcelWithDateRange(exportRange[0], exportRange[1]);
            }}
          >
            Download Excel
          </ButtonAntd>
        </div>
      </Modal>

      <style>{`
             .timeline {
                list-style: none;
                padding-left: 0;
              }

              .timeline li {
                position: relative;
                padding-left: 20px;
                margin-bottom: 12px;
              }

              .timeline li::before {
                content: "•";
                position: absolute;
                left: 0;
                color: #0d6efd;
              }

              .journey-list {
                list-style: none;
                padding: 0;
                margin: 0;
              }

              .journey-item {
                display: flex;
                align-items: flex-start;
                gap: 12px;
                padding: 12px;
                margin-bottom: 10px;
                background: #f8f9fa;
                border-radius: 8px;
              }

              .journey-step {
                width: 28px;
                height: 28px;
                min-width: 28px;
                border-radius: 50%;
                background: #0d6efd;
                color: #fff;
                font-size: 13px;
                font-weight: 600;
                display: flex;
                align-items: center;
                justify-content: center;
              }

              .journey-content {
                flex: 1;
              }

              .journey-title {
                font-weight: 600;
                font-size: 14px;
              }

              .journey-meta {
                font-size: 12px;
                color: #6c757d;
              }

            `}</style>
      {showJourneyModal && (
        <ModalReact
          show
          onHide={() => {
            setShowJourneyModal(false);
            setJourneyData([]);
            setSelectedJourneyNumber(null);
          }}
          size="lg"
        >
          <ModalReact.Header closeButton>
            <ModalReact.Title>Call Journey</ModalReact.Title>
          </ModalReact.Header>

          <ModalReact.Body>
            <div className="row">
              <div className="col-md-8">
                <h6 className="mb-3">
                  Journey Timeline
                  {selectedJourneyNumber && (
                    <span className="text-muted ms-2">
                      ({selectedJourneyNumber})
                    </span>
                  )}
                </h6>

                {!selectedJourneyNumber ? (
                  <p className="text-muted">Please select a number</p>
                ) : journeyData.length === 0 ? (
                  <p className="text-muted">Loading...</p>
                ) : (
                  <div
                    style={{
                      maxHeight: "420px",
                      overflowY: "auto",
                    }}
                  >
                    <ul className="journey-list">
                      {journeyData.map((item: any, index: number) => (
                        <li key={index} className="journey-item">
                          <div className="journey-step">
                            {journeyData.length - index}
                          </div>

                          <div className="journey-content">
                            <div className="journey-title">
                              {item.call_event}
                            </div>
                            <div className="journey-meta">
                              {moment(item.start_time).format(
                                "DD-MM-YYYY hh:mm A",
                              )}
                              {item.call_duration > 0 && (
                                <span> • {item.call_duration}s</span>
                              )}
                            </div>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </ModalReact.Body>
        </ModalReact>
      )}
    </>
  );
};

export default CallLogs;
